export default __webpack_public_path__ + "static/media/deepl.6ddb271a.png";